<div class="p-4 md:p-6">
  <div class="flex items-center justify-between mb-4">
    <h2 class="text-xl font-semibold text-slate-800">User Event History (Last 50)</h2>
    <button
      type="button"
      class="px-3 py-2 text-sm rounded-md bg-red-500 text-white hover:bg-red-600 disabled:opacity-60"
      [disabled]="events.length === 0"
      (click)="clearAll()"
    >
      Clear History
    </button>
  </div>

  <div class="bg-white rounded-lg border border-slate-200 overflow-hidden">
    <p-table
      [value]="events"
      [paginator]="false"
      [rows]="50"
      class="w-full text-sm"
      [styleClass]="'event-history-table'"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Action</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="action" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Method</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="meta.method" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Status</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="meta.status" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Code</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="meta.statusCode" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Duration</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="meta.durationMs" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Path</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="path" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Details</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="details" display="menu"></p-columnFilter>
            </div>
          </th>
          <th class="text-left px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-wrap text-wrap-break">Time</span>
              </div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" field="createdAt" display="menu"></p-columnFilter>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event>
        <tr>
          <td class="px-4 py-3 font-medium text-slate-800">{{ event.action }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.meta?.method || '-' }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.meta?.status || '-' }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.meta?.statusCode ?? '-' }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.meta?.durationMs ? (event.meta?.durationMs + ' ms') : '-' }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.path }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.details || '-' }}</td>
          <td class="px-4 py-3 text-slate-700">{{ event.createdAt | date: 'dd-MMM-yyyy hh:mm a' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="px-4 py-8 text-center text-slate-500">
            No events tracked yet.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
